export default "__VITE_ASSET__BiK5npJU__"